<main class="page-container">
  @if (loading && records.length === 0) {
    <app-loading [fullscreen]="true" label="Cargando auditoría..."></app-loading>
  }
  <app-page-header
    title="Auditoría global"
    description="Consulta la trazabilidad de las acciones realizadas en el sistema."
  >
    <app-button variant="outlined" (clicked)="loadRecords()" [loading]="loading">
      <i button-icon class="fa-solid fa-rotate-right"></i> Actualizar
    </app-button>
  </app-page-header>

  <section class="audit-filters">
    <div class="field">
      <label for="audit-action">Acción</label>
      <input
        id="audit-action"
        name="auditAction"
        type="text"
        maxlength="30"
        placeholder="Ej. CREATE"
        [(ngModel)]="filters.accion"
      />
    </div>
    <div class="field">
      <label for="audit-entity">Entidad</label>
      <input
        id="audit-entity"
        type="text"
        placeholder="Ej. Usuario"
        maxlength="100"
        [(ngModel)]="filters.entidad"
      />
    </div>
    <div class="field">
      <label for="audit-company">Empresa</label>
      <input
        id="audit-company"
        type="text"
        placeholder="UUID de empresa"
        maxlength="36"
        [(ngModel)]="filters.empresaId"
      />
    </div>
    <div class="field">
      <label for="audit-from">Desde</label>
      <input
        id="audit-from"
        name="auditFrom"
        type="date"
        [max]="maxDate"
        [(ngModel)]="filters.desde"
      />
    </div>
    <div class="field">
      <label for="audit-to">Hasta</label>
      <input id="audit-to" name="auditTo" type="date" [max]="maxDate" [(ngModel)]="filters.hasta" />
    </div>
    <div class="filter-actions">
      <app-button variant="primary" (clicked)="applyFilters()">
        <i button-icon class="fa-solid fa-filter"></i> Filtrar
      </app-button>
      <app-button variant="text" (clicked)="clearFilters()">Limpiar</app-button>
    </div>
  </section>

  @if (errorMessage) {
    <div class="audit-error" role="alert">
      <i class="fa-solid fa-circle-exclamation"></i>
      <span>{{ errorMessage }}</span>
    </div>
  }

  @if (mobileService.isMobile()) {
    <section class="data-section-card audit-table-card">
      <app-card-list
        title="Registro de actividad"
        description="Acciones ordenadas de la más reciente a la más antigua"
        countLabel="registros"
        [items]="records"
        [loading]="loading"
        [emptyMessage]="'No hay registros para los filtros seleccionados.'"
        [page]="page"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        [showPageSize]="false"
        (pageChange)="onPageChange($event)"
      >
        <ng-template #card let-record>
          <article class="card-list-item audit-card">
            <header class="card-list-item-header audit-card-header">
              <div class="audit-card-heading">
                <div class="audit-card-title">
                  <strong>{{ record.nombreEntidad }}</strong>
                  <span class="action-badge" [class]="actionClass(record.accion)">
                    {{ record.accion }}
                  </span>
                </div>
              </div>
            </header>
            <div class="card-list-item-body">
              <div class="card-list-item-details audit-card-details">
                <span class="card-list-item-label"
                  >Fecha:
                  <span class="card-list-item-value">
                    {{ record.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                  </span>
                </span>

                <span class="card-list-item-label"
                  >Usuario:
                  <span class="card-list-item-value">
                    {{ record.usuario ?? 'Sistema' }}
                  </span>
                </span>
              </div>
            </div>
            <footer class="card-list-item-actions audit-card-actions">
              <app-button
                type="button"
                variant="outlined"
                size="small"
                (clicked)="viewDetails(record)"
              >
                <i class="fa-solid fa-eye"></i>
                Ver detalles
              </app-button>
            </footer>
          </article>
        </ng-template>
      </app-card-list>
    </section>
  } @else {
    <app-data-table-paginado
      [columns]="columns"
      [data]="records"
      title="Registro de actividad"
      description="Acciones ordenadas de la más reciente a la más antigua"
      [showHeader]="true"
      countLabel="registros"
      [loading]="loading"
      [page]="page"
      [pageSize]="pageSize"
      [totalItems]="totalItems"
      [showPageSize]="false"
      emptyMessage="No hay registros para los filtros seleccionados."
      (pageChange)="onPageChange($event)"
      (action)="onAction($event)"
    ></app-data-table-paginado>
  }

  @if (showModalDetails && selectedRecord) {
    <app-modal-shell
      title="Detalles de auditoría"
      description="Información completa de la operación registrada."
      size="large"
      [closeOnBackdrop]="true"
      (closed)="closeDetails()"
    >
      <div class="audit-details">
        <div class="audit-details-summary">
          <div class="audit-detail-item">
            <span>Fecha</span>
            <strong>{{ selectedRecord.fechaCreacion | date: 'yyyy-MM-dd HH:mm:ss' }}</strong>
          </div>
          <div class="audit-detail-item">
            <span>Usuario</span>
            <strong>{{ selectedRecord.usuario ?? 'Sistema' }}</strong>
          </div>
          <div class="audit-detail-item">
            <span>Acción</span>
            <span class="action-badge" [class]="actionClass(selectedRecord.accion)">{{
              selectedRecord.accion
            }}</span>
          </div>
          <div class="audit-detail-item">
            <span>Entidad</span>
            <strong>{{ selectedRecord.nombreEntidad }}</strong>
          </div>
          <div class="audit-detail-item audit-detail-item-wide">
            <span>Identificador</span>
            <code>{{ selectedRecord.identificadorEntidad ?? '—' }}</code>
          </div>
        </div>

        <section class="audit-json-panel" aria-labelledby="audit-json-title">
          <header class="audit-json-header">
            <div>
              <i class="fa-solid fa-code" aria-hidden="true"></i>
              <strong id="audit-json-title">Detalles del cambio</strong>
            </div>
            <span>JSON</span>
          </header>
          <pre class="audit-json"><code>{{ formatDetails(selectedRecord.detalles) }}</code></pre>
        </section>
      </div>

      <footer class="modal-footer">
        <app-button variant="primary" (clicked)="closeDetails()">Cerrar</app-button>
      </footer>
    </app-modal-shell>
  }
</main>
